module.exports = __webpack_public_path__ + "img/986.04b248b2.gif";